/**
 * Store some variables that we want to access
 * here and there
 */

/**
 * The routes are good to be consistent with.
 */
export const LOGIN_PATH = 'autentisering'
export const DOCUMENT_PATH = 'dokument'

